<template>
  <div class="page-header clear-filter" filter-color="">
    <div
      class="page-header-image"
      style="background-image: url('img/gate_tef.jpeg')"
    ></div>
    <div class="content">
      <div class="container">
        <div class="col-md-5 ml-auto mr-auto">
          <card type="login" plain style="margin-top: 50px;">
            <!-- <div slot="header" class="logo-container">
              <img v-lazy="'img/now-logo.png'" alt="" />
            </div> -->

            <fg-input
              class="no-border input-lg mb-1"
              addon-left-icon="now-ui-icons ui-1_email-85"
              placeholder="Email"
              required
              v-model="email"
              v-on:keyup.enter="login()"
            >
            </fg-input>
            <fg-input
              class="no-border input-lg mb-1"
              addon-left-icon="now-ui-icons objects_key-25"
              placeholder="Password"
              type="password"
              required
              v-model="password"
              v-on:keyup.enter="login()"
            >
            </fg-input>

            <template slot="raw-content">
              <div class="card-footer text-center">
                <n-button type="default" size="sm" class="btn btn-success btn-round btn-lg btn-block" @click.native="login()" style="padding: 10px;">
                  <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
                  <span v-else>
                      <span>Login</span>
                  </span>
                </n-button>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
    <main-footer></main-footer>
  </div>
</template>
<script>
import { Card, Button, FormGroupInput } from '@/components';
import MainFooter from '@/layout/MainFooter';
import adminAuth from '@/services/adminAuth.service';
import adminAuthHeader from '@/helpers/adminAuthHeader';

export default {
  name: 'login-page',
  bodyClass: 'login-page',
  components: {
    Card,
    MainFooter,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data() {
    return {
      email: '',
      password: '',
      onLoading: false,
    };
  },
  methods: {
    login() {
      if (this.email && this.password) {
        this.onLoading = true;
        adminAuth.login({ email: this.email, password: this.password }).then((response) => {
          adminAuthHeader.set(response.data.data.token);
          this.$notify('Login successful', 'success');
          this.$router.push('/admin/blog');
        }).catch(() => {
          this.$notify('Invalid email or password', 'error');
        }).finally(() => {
          this.onLoading = false;
        });
      } else {
        this.$notify('Email and password are required', 'error');
      }
    },
  }
};
</script>
<style></style>
